import { Fab } from "@mui/material";
import React from "react";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FieldInfoDialog from "../../common/dialogs/FieldInfoDialog";
import FieldInfoContent from "../../common/components/FieldInfoContent";
import { FieldDataItem } from "../../common/classes/field_data_item";
import CardButton from "../../common/components/CardButton";

export interface AreaInfoProps {
  open?: boolean;
  width?: number;
  collapsedHeight?: number;
  minimized?: boolean;
  field?: {
    id: number;
    name: string;
  } | null;
  agricultureAnalysisData?: {
    id: number;
    phase: string;
  };
  fieldDataItems?: FieldDataItem[];
  fieldBoundary?: google.maps.LatLngLiteral[];
  photogrammetry?: boolean;
}

const AreaInfo = (props: AreaInfoProps) => {
  const [ open, setOpen ] = React.useState<boolean>(props.open ?? false);

  if (props.minimized) {
    return (
      <React.Fragment>
        <Fab 
          sx={{
            backgroundColor: "white"
          }}
          onClick={() => {
            setOpen(true);
          }}
        >
          <InfoOutlinedIcon />
        </Fab>
        <FieldInfoDialog
          open={open}
          onClose={() => setOpen(false)}
          field={props.field}
          fieldDataItems={props.fieldDataItems}
          agricultureAnalysisData={props.agricultureAnalysisData ?? undefined}
          fieldBoundary={props.fieldBoundary}
          photogrammetry={props.photogrammetry}
        />

      </React.Fragment>
    );
  }

  return (
    <CardButton
      style={{ 
        width: props.width ?? 150,
        height: open ? undefined : props.collapsedHeight ?? 55
      }}
      onClick={() => setOpen(prev => !prev)}
      text={props.field?.name ?? ""}
      showMore={!open}
      showLess={open}
    >
      {open &&
        <FieldInfoContent
          field={props.field}
          agricultureAnalysisData={props.agricultureAnalysisData}
          fieldDataItems={props.fieldDataItems}
          fieldBoundary={props.fieldBoundary}
          displayMode="stack"
          showAreaInfo={true}
          photogrammetry={props.photogrammetry}
        />
      }
    </CardButton>
  )
};

export default AreaInfo;
